import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ZDivider } from '@zanichelli/albe-web-components/react';

import { SOURCES } from '../../../../constants/sources';
import { CORRECTION } from '../../../../constants/execution-modes';
import { getRedirectToSource, getSourceLabel } from '../../../../lib/utils';
import { hideModal as hideModalAction } from '../../../../actions/modal';
import Spacer from '../../../spacer';

import Modal from '../..';
import Buttons from '../../buttons';
import { Content, ModalBodyContainer } from '../../components';
import { DividerSize } from '@zanichelli/albe-web-components';

export const Alert = styled.span`
    text-transform: uppercase;
    color: var(--red700);
`;

export const NotLoggedModalMessage = ({ executionMode, finished, saveStatus, source }) => {
    if (executionMode === CORRECTION || (saveStatus && finished)) {
        return (
            <div className="body-3">
                {`Torna su ${getSourceLabel(source)} e inserisci di nuovo le tue credenziali per rientrare e riaprire la correzione.`}
            </div>
        );
    }
    if (source === SOURCES.TT) {
        return (
            <div className="body-3">
                {`Torna su Tutor e inserisci di nuovo le tue credenziali per rientrare.`}
                <Spacer size="base" />
                <div className="body-3-sb">{`Puoi riprendere l’esercitazione da dove eri rimasto: la trovi nel tuo Quaderno.`}</div>
            </div>
        );
    }
    if (saveStatus) {
        return (
            <div className="body-3">
                {`Torna su ${getSourceLabel(source)} e inserisci di nuovo le tue credenziali per rientrare.`}
                <Spacer size="base" />
                <div className="body-3-sb">{`Stavi svolgendo una verifica o una prova assegnata?`}</div>
                {`Puoi riprendere da dove eri rimasto: la trovi nel tuo Quaderno.`}
            </div>
        );
    }
    return (
        <div className="body-3">
            {`Torna su ${getSourceLabel(source)} e inserisci di nuovo le tue credenziali per rientrare.`}
            <Spacer size="base" />
            <div className="body-3-sb">{`Stavi svolgendo un Allenamento?`}</div>
            {`Gli Allenamenti non vengono salvati sul Quaderno, ma puoi continuare a svolgere la prova adesso, senza bisogno di effettuare nuovamente l’accesso.`}
        </div>
    );
};

export const NotLoggedModalButtonBar = ({ executionMode, source, saveStatus, hideModal, bookId, homeworkId, backToHome }) => {
    const isZteTrial = source === SOURCES.ZTE_SCUOLA && saveStatus === false;

    const isTrial = isZteTrial && executionMode !== CORRECTION;
    const closeViewerMessage = `Chiudi e torna su ${getSourceLabel(source)}`;

    return (
        <Buttons
            primaryButtonClick={
                isTrial ? hideModal : () => (window.location.href = getRedirectToSource(source, bookId, homeworkId, backToHome))
            }
            primaryButtonText={isTrial ? 'Continua questa prova' : closeViewerMessage}
            showTertiaryButton={isTrial}
            tertiaryButtonClick={() => (window.location.href = getRedirectToSource(source, bookId, homeworkId, backToHome))}
            tertiaryButtonText={closeViewerMessage}
            showCloseButton={false}
        />
    );
};

export const NotLoggedModalBody = ({ executionMode, finished, bookId, homeworkId, hideModal, saveStatus, source, isOpenAssignment }) => {
    return (
        <Modal title="Account scollegato" closeOnClickOutside={false} showCloseButton={false}>
            <ModalBodyContainer>
                <Content customWidth="calc(var(--space-unit) * 55)">
                    <Alert className="body-4-sb">
                        {'Hai scollegato il tuo account o lo stai usando da un altro dispositivo o browser?'}
                    </Alert>
                    <Spacer size="base" />
                    <ZDivider size={DividerSize.SMALL} color="gray800" />
                    <Spacer size="base" />
                    <NotLoggedModalMessage executionMode={executionMode} finished={finished} saveStatus={saveStatus} source={source} />
                </Content>
                <NotLoggedModalButtonBar
                    bookId={bookId}
                    homeworkId={!isOpenAssignment ? homeworkId : undefined}
                    executionMode={executionMode}
                    saveStatus={saveStatus}
                    source={source}
                    hideModal={hideModal}
                />
            </ModalBodyContainer>
        </Modal>
    );
};

NotLoggedModalMessage.propTypes = {
    executionMode: PropTypes.string,
    finished: PropTypes.bool,
    saveStatus: PropTypes.bool,
    source: PropTypes.string,
};

NotLoggedModalButtonBar.propTypes = {
    bookId: PropTypes.number,
    homeworkId: PropTypes.string,
    executionMode: PropTypes.string,
    hideModal: PropTypes.func,
    pauseHomework: PropTypes.func,
    saveStatus: PropTypes.bool,
    source: PropTypes.string,
    backToHome: PropTypes.bool,
};

NotLoggedModalBody.propTypes = {
    executionMode: PropTypes.string,
    finished: PropTypes.bool,
    bookId: PropTypes.number,
    homeworkId: PropTypes.string,
    hideModal: PropTypes.func,
    saveStatus: PropTypes.bool,
    source: PropTypes.string,
    isOpenAssignment: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        executionMode: state.application.executionMode,
        finished: state.status.finished,
        bookId: state.homework.bookId,
        homeworkId: state.homework.id,
        saveStatus: state.application.saveStatus,
        source: state.application.source,
        isOpenAssignment: state.application.isOpenAssignment,
        backToHome: state.application.backToHome,
    };
};

const actionCreators = {
    hideModal: hideModalAction,
};

export default connect(mapStateToProps, actionCreators)(NotLoggedModalBody);
